import React, { useRef, useState, useEffect } from 'react';
import { GameSimulation } from './gameSimulation';
import GameStage from './GameStage';
import GameUI from './GameUI';
import DebugModal from './DebugModal';

function Game({ levelNumber, app, onGameFinish }) {
  const renderer = useRef(null);
  const [gameVersion, setGameVersion] = useState(0);
  const [screenDimensions, setScreenDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  
  useEffect(() => {
    // Function to update screen dimensions
    const updateDimensions = () => {
      setScreenDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    
    // Set initial dimensions
    updateDimensions();
    
    // Add event listener for window resize
    window.addEventListener('resize', updateDimensions);
    
    // Clean up event listener
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  if (!renderer.current) {
    renderer.current = new GameSimulation(
      levelNumber, 
      screenDimensions.width, 
      screenDimensions.height
    );
  }

  const handleGameFinish = () => {
    const isVictory = renderer.current.isWon;
    renderer.current = new GameSimulation(
      levelNumber, 
      screenDimensions.width, 
      screenDimensions.height
    );
    setGameVersion(v => v + 1);
    onGameFinish(isVictory);
  };

  return (
    <div className="relative w-full h-full">
      <div className="absolute inset-0">
        <GameStage key={gameVersion} game={renderer.current} />
      </div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="pointer-events-auto">
          <GameUI 
            key={gameVersion} 
            game={renderer.current} 
            onFinishGame={handleGameFinish} 
            onExit={() => app.goToMap()} 
          />
        </div>
      </div>
    </div>
  );
}

export default Game;
